import { Link } from '@mui/material';

export const WorkQueueColumnDefinitions = () => [
	{
		field: 'subject',
		headerName: 'Subject',
		editable: false,
		sortable: true,
		flex: 4,
		minWidth: 280,
		renderCell: (params) => (
			<Link
				component='span'
				underline='hover'
				sx={{
					fontSize: '12px',
					fontWeight: 500,
					textAlign: 'left',
				}}
			>
				{params.value || ''}
			</Link>
		),
	},
	{
		field: 'assigned_to',
		headerName: 'Assigned To',
		editable: false,
		sortable: false,
		flex: 1.5,
		minWidth: 120,
	},
	{
		field: 'status',
		headerName: 'Status',
		editable: false,
		sortable: true,
		flex: 1,
		minWidth: 110,
	},
	{
		field: 'priority',
		headerName: 'Priority',
		editable: false,
		sortable: true,
		flex: 1,
		minWidth: 100,
	},
	{
		field: 'due_date',
		headerName: 'Due Date',
		editable: false,
		sortable: true,
		flex: 1.3,
		minWidth: 120,
	},
	{
		field: 'related_to',
		headerName: 'Related To',
		editable: false,
		sortable: true,
		flex: 2,
		minWidth: 160,
	},
];
